import _ from 'lodash'

export const receiveError = (errorType, errors) => {
    return {
        type: errorType,
        errors
    }
};

const mapResponseErrorsToMessage = (error) => {
    const request_id = _.get(error, ['response', 'body', 'error', 'request_id']);
    const errorMessageExtra = request_id
        ? `When contacting support, please quote Request ID '${request_id}'`
        : '';

    return {
        // We want to hide real messages from user since traces are confusing to them
        // TODO: coordinate with API to surface proper errors such as field validation?
        messages: [
            'PACER is experiencing some issues. Please try again in a few minutes.',
            errorMessageExtra
        ],
        // but we include the real message in the details so we receive it in the sentry report
        details: _.get(error, ['response', 'body', 'error'])
    };
};

export const onFailure = (dispatch) => {
    return function (error) {
        return dispatch(receiveError(mapResponseErrorsToMessage(error)))
    }
};


// WEBPACK FOOTER //
// ./src/redux/actions/errorAction.js